import { ConsentMode, ConsentModeValue } from "../types/consent";

import { hasAnalyticsConsent, hasFunctionalityConsent, hasMarketingConsent } from "./consent";

interface CookiebotConsentCategories {
  necessary: boolean;
  preferences: boolean;
  statistics: boolean;
  marketing: boolean;
}

export interface Cookiebot {
  consent: CookiebotConsentCategories;
  consented: boolean;
  declined: boolean;
  hasResponse: boolean;
  submitCustomConsent: (preferences: boolean, statistics: boolean, marketing: boolean) => void;
}

declare global {
  interface Window {
    Cookiebot?: Cookiebot;
  }
}

export const COOKIEBOT_EVENTS = [
  "CookiebotOnLoad",
  "CookiebotOnConsentReady",
  "CookiebotOnAccept",
  "CookiebotOnDecline",
] as const;

const toConsentModeValue = (isGranted: boolean): ConsentModeValue => (isGranted ? "granted" : "denied");

export const hasCookiebotDecision = (cookiebot: Cookiebot): boolean =>
  cookiebot.hasResponse || cookiebot.consented || cookiebot.declined;

export const getConsentModeFromCookiebot = (cookiebot: Cookiebot): ConsentMode | undefined => {
  if (!hasCookiebotDecision(cookiebot)) {
    return undefined;
  }
  const { preferences, statistics, marketing } = cookiebot.consent;
  return {
    ad_storage: toConsentModeValue(marketing),
    analytics_storage: toConsentModeValue(statistics),
    functionality_storage: toConsentModeValue(preferences),
    personalization_storage: toConsentModeValue(preferences),
    security_storage: "granted",
  };
};

export const submitConsentModeToCookiebot = (cookiebot: Cookiebot, consentMode: ConsentMode) =>
  cookiebot.submitCustomConsent(
    hasFunctionalityConsent(consentMode),
    hasAnalyticsConsent(consentMode),
    hasMarketingConsent(consentMode)
  );
